import React, { useMemo } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import DashboardMetricCard from "./DashboardMetricCard";
import { DASHBOARD_METRIC_CARDS } from "./dashboardConfig";

// #region SCOPED CSS
const StyledMetricsGrid = styled.div`
    width: 100%;
    display: grid;
    flex-shrink: 0;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 24px;

    @media (max-width: 1700px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 850px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 560px) {
        grid-template-columns: 1fr;
    }
`;
// #endregion

export default function DashboardMetricsRow({ dashboardData, isLoading = false, onCardAction }) {
    // #region VARS
    const navigate = useNavigate();
    // #endregion

    // #region COMPUTED PROPS
    const cards = useMemo(
        () =>
            DASHBOARD_METRIC_CARDS.map(card => ({
                ...card,
                items: card.items.map(item => ({
                    ...item,
                    value: dashboardData?.[card.dataKey]?.[item.dataKey] ?? "-"
                }))
            })),
        [dashboardData]
    );
    // #endregion

    // #region METHODS
    const handleCardAction = (card, action) => {
        if (typeof onCardAction === "function") {
            onCardAction(card, action);
            return;
        }

        if (action?.route) navigate(action.route);
    };
    // #endregion

    // #region RENDER
    return (
        <StyledMetricsGrid className="dashboard-metrics-grid" aria-busy={isLoading}>
            {cards.map(card => (
                <DashboardMetricCard
                    key={card.id}
                    title={card.title}
                    items={card.items}
                    actions={card.actions}
                    isLoading={isLoading}
                    onAction={action => handleCardAction(card, action)}
                />
            ))}
        </StyledMetricsGrid>
    );
    // #endregion
}
